<template>
    <v-container class="blogger-content-container">
        <v-row style="color: grey;margin-left:8%">
            <v-col v-if="createTime">
                创建时间:{{ createTime }}
            </v-col>
            <v-col v-if="category">
               标签:{{ category }}
            </v-col>
            <v-col v-if="tags">
                分类:{{ tags }} 
            </v-col>
        </v-row>
        <div class="blogger-content-md">
            <markdown-preview :initialValue="text" theme="gitHub"> </markdown-preview>
        </div>
   </v-container>
</template>

<script>
import { MarkdownPreview } from 'vue-meditor'

export default {
    components:{
        MarkdownPreview
    },
    data() {
        return {
          text:'',
          createTime:"",
          category:"",
          tags:""
        }
    },
    methods: {
        getMdData(){
            let _this = this;
            let md_path = _this.$store.state.blogPath;
            if(!md_path){
                return
            }
            _this.$http.get("articles/"+md_path).then(res => {
                if (res.status == 200){
                    _this.text = res.data;
                    _this.getMetaData(_this.text);
                }
            });
        },
        getMetaData(content){
            let _this = this;
            let context = content.substring(0, 256);
            let _createTime = context.match(/createTime=\"(.*?)\"/);
            let _category = context.match(/category=\"(.*?)\"/);
            let _tags = context.match(/tags=\"(.*?)\"/);
            try {
                _this.createTime = _createTime[1];
            } catch (error) {
                _this.createTime = "";
            }
            try {
                _this.category = _category[1];
            } catch (error) {
                _this.category = "";
            }
            try {
                _this.tags = _tags[1];
            } catch (error) {
                _this.tags = "";
            }
        }
    },
    mounted(){
        let _this = this;
        _this.getMdData();
    }
}
</script>

<style lang="stylus" scoped>

.blogger-content-container
    top 0
    left 5%
    right 0
    bottom 0
    width 100%
    height 100%
    position relative
.blogger-content-md
    width 95%
    height 95%
    margin-left 3%
    overflow auto
</style>